import { css } from "styled-components";
import { mobile, tabletP, tabletL, pc, tablet } from "./responsive";

/* ------------------------------------------------------------------ */
/*  폰트 크기 전역 토큰 (단일 소스)                                     */
/*  - 각 역할(role)별 브레이크포인트 크기를 여기서 관리한다.           */
/*  - 컴포넌트에서는 responsiveFont(FONT.<role>) 로 적용.              */
/*  - 키는 pc / tabletL / tabletP / tablet(가로+세로 공통) / mobile.   */
/* ------------------------------------------------------------------ */
export type FontSizes = {
  pc?: number;
  tabletL?: number;
  tabletP?: number;
  tablet?: number; // 태블릿 가로+세로 공통
  mobile?: number;
};

export const FONT: Record<string, FontSizes> = {
  // 홈 메뉴 카드
  cardTitle: { pc: 22, tablet: 21, mobile: 19 },
  cardDesc: { pc: 15.5, tablet: 15, mobile: 13.5 },

  // 홈 인사말
  greetingTitle: { pc: 32, tabletL: 28, tabletP: 26, mobile: 22 },
  greetingSub: { pc: 15, tablet: 14, mobile: 13 },
};

/* 역할별 폰트 크기를 브레이크포인트 미디어쿼리로 적용하는 css 스니펫 */
export const responsiveFont = (s: FontSizes) => css`
  ${s.pc != null ? `${pc} { font-size: ${s.pc}px; }` : ""}
  ${s.tabletL != null ? `${tabletL} { font-size: ${s.tabletL}px; }` : ""}
  ${s.tabletP != null ? `${tabletP} { font-size: ${s.tabletP}px; }` : ""}
  ${s.tablet != null ? `${tablet} { font-size: ${s.tablet}px; }` : ""}
  ${s.mobile != null ? `${mobile} { font-size: ${s.mobile}px; }` : ""}
`;
